module.exports = __webpack_public_path__ + "static/media/mask-tool-white.515fd811.svg";